import Controller, { OnAfterFetch, OnChange, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { FetchEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { FragmentNames, MaterialEducationalDetailAliases} from '../../codegen';
import {CardMaterialEducationProps } from '@philips-emr/patient-components/src';
import BaseController from '../BaseController';
import { Inject } from '@odinjs/odin';
import { FetchAPI, ImageAPI, PanelAPI, TagAPI, TextAPI } from '@philips-internal/oswald-ui-components';
import { ChangeEvent, MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import './material-education-detail-controller.css';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { resolvePath } from '@philips-internal/oswald-ui-utils';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import { Value } from '@philips-internal/oswald-ui-core';
import HtmlViewerAPI from '@philips-emr/patient-components/src/components/html-viewer/html-viewer-api';

@Controller({component: MaterialEducationalDetailAliases.MATERIAL_DETAIL_LAYOUT, fragment: FragmentNames.MATERIAL_EDUCATIONAL_DETAIL })
export default class MaterialEducationDetailController extends BaseController {

  @Inject(MaterialEducationalDetailAliases.TITLE_DETAIL_TEXT)
    titleTextAPI!: TextAPI;

  @Inject(MaterialEducationalDetailAliases.SUBTITLE_DETAIL_TEXT)
    subTitleTextAPI!: TextAPI;

  @Inject(MaterialEducationalDetailAliases.DATE_DETAIL_TEXT)
    dateTextAPI!: TextAPI;

  @Inject('tag-category')
    tagCategoryAPI!: TagAPI;

  @Inject('detail-image')
    detailImageAPI!: ImageAPI;

  @Inject('panel-alt-image')
    panelImageAPI!: PanelAPI;

  @Inject(MaterialEducationalDetailAliases.HTML_VIEWER_DETAIL)
    htmlViewerdetailAPI!: HtmlViewerAPI;

  @OnMount({target:MaterialEducationalDetailAliases.MATERIAL_DETAIL_FETCH})
  onMountFetch(evt:MountEvent):void{
    const fetchApi = evt.target as FetchAPI;
    const params = this.historyService.getCurrentRouteParams() as Record<string, Value>;
    if (params) {
      fetchApi.setParameters(params)
    }
    fetchApi.forceFetch()
  }

  @OnMount({target:MaterialEducationalDetailAliases.FETCH_DETAIL_CARDS})
  onMountFetchCards(evt:MountEvent):void{
    const fetchApi = evt.target as FetchAPI;
    fetchApi.setParameters({ limit: 3, page: 0 });
    fetchApi.forceFetch();
  }

  @OnChange({target:MaterialEducationalDetailAliases.SEGMENTED_CONTROL_DETAIL_CARDS})
  onClickCardMainPatient(evt:ChangeEvent<string>): void {

    const material =  evt.value[0] as unknown as CardMaterialEducationProps
    this.historyService.push(APPLICATION_ROUTES.MATERIAL_EDUCATIONAL_DETAIL, {nrSequence : material.nrSequencia})
  }

  @OnAfterFetch({target:MaterialEducationalDetailAliases.MATERIAL_DETAIL_FETCH})
  onAfterFetch(evt:FetchEvent):void{
    const detailData = evt.data as CardMaterialEducationProps;
    const preparation = 'PRE'
    const GET_PREVIEW_DOCUMENT = '/patient-service/resources/files/preview'
    const iconPatch = '/static/assets/icons/DLS_Articles.svg'
    const imageSrc = detailData.dsImage ? resolvePath(`${GET_PREVIEW_DOCUMENT}?uri=:uri`, { uri: detailData.dsImage }) : iconPatch;
    const imageClassName = detailData.dsImage ? 'upload-detail-image' : 'articles-icon'
    const panelImageClassName = detailData.dsImage ? 'panel-upload-image' : 'panel-alt-image'

    this.panelImageAPI.setClassName(panelImageClassName)
    this.detailImageAPI.setSrc(imageSrc)
    this.detailImageAPI.setClassName(imageClassName)

    this.titleTextAPI.setValue(detailData.dsTitulo)
    this.subTitleTextAPI.setValue(detailData.dsSubTitulo)
    this.tagCategoryAPI.setValue(preparation === detailData.dsPrePos ? MessageService.translate('patient.education.preparation') : MessageService.translate('patient.education.procedure') )
    this.dateTextAPI.setValue(detailData.dsData)
    this.htmlViewerdetailAPI.setHtmlContent(detailData.dsTexto)
  }

}